


@if (is_logged_in) {
  <!--  <app-nav-campaigns>-->
  <router-outlet></router-outlet>
<!--  </app-nav-campaigns>-->
}

@if (!is_logged_in) {
  <mat-toolbar color="primary"><span class="ref"></span></mat-toolbar>
  <router-outlet></router-outlet>
}
